import React from 'react';
import { RefinementList } from 'react-instantsearch';
import sortBy from 'lodash.sortby';

import MwobFilters from './MwobFilters';
import FilterBlock from '../../elements/FilterBlock';
import { useScreenMinLg } from '@hooks/useResponsive';
import { HierarchicalMenuMulti } from '@search';

const transformBusinessType = items => sortBy(items, ['label']);

const CompanyFilters = () => {
    const isScreenMinLg = useScreenMinLg();

    return (
        <>
            <FilterBlock label="Business Type" defaultExpanded={isScreenMinLg}>
                <div className="mb-3">
                    <HierarchicalMenuMulti
                        attribute="business_type"
                        limit={99999}
                        transformItems={transformBusinessType}
                    />
                </div>
            </FilterBlock>

            <FilterBlock label="Country">
                <RefinementList attribute="location.country" limit={99999} />
            </FilterBlock>

            <FilterBlock label="State/Province">
                <RefinementList attribute="location.state" limit={99999} />
            </FilterBlock>

            <FilterBlock label="Global Region">
                <RefinementList attribute="location.region" limit={99999} />
            </FilterBlock>

            <MwobFilters />
        </>
    );
};

export default CompanyFilters;
